import {
    FormControl, FormLabel, Stack,
    Icon, InputAdornment,
    TextField, IconButton
} from '@mui/material'

import { forwardRef } from 'react'

import Styles from './style'

export const Textinput = forwardRef((props, ref) => {
    const labelVariant = props.labelVariant || 'primary'
    const variant = props.variant || 'primary'

    const searchIcon = (
        <InputAdornment position={'start'}>
            <Icon>{props.searchIcon || Styles.searchIcon}</Icon>
        </InputAdornment>
    )

    const resetIcon = (
        <InputAdornment position={'end'}>
            <IconButton onClick={props.field.onReset} tabIndex={-1}>
                <Icon>{props.resetIcon || Styles.resetIcon}</Icon>
            </IconButton>
        </InputAdornment>
    )

    return (
        <FormControl sx={props.sx || {}} ref={ref}>
            {props.label && (<FormLabel variant={labelVariant}>{props.label} {props.required && (<span style={{color: Styles.requiredColor}}>*</span>)}</FormLabel>)}
            <TextField
                sx={Styles.variants[variant]}
                fullWidth
                size={'small'}
                error={props.error}
                className={(props.success) ? 'inputSuccess' : ''}
                InputProps={
                    {
                        startAdornment: (props.search) ? searchIcon : '',
                        endAdornment: (props.field?.onReset && (props.field?.value && props.field?.value.length > 0)) ? resetIcon : ''
                    }
                }
                {...props.field}
            />
            {(props.sublabel || props.error || props.success) && (
                <FormLabel error={props.error} variant={(props.success) ? 'success' : labelVariant}>
                    <Stack direction={'row'} alignItems={'center'}>
                        {props.error && props.errorLabel && (<Icon color={'error'} sx={{fontSize: '16px', fontVariationSettings: "'FILL' 1"}}>error</Icon>)}
                        {props.error && props.errorLabel}
                        {props.success && props.successLabel && (<Icon color={'success'} sx={{fontSize: '16px', fontVariationSettings: "'FILL' 1"}}>check_circle</Icon>)}
                        {props.success && props.successLabel}
                        {!props.success && !props.success && props.sublabel}
                    </Stack>
                </FormLabel>
            )}
        </FormControl>
    )
})

Textinput.displayName = 'Textinput'

export default Textinput